import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  id: 1,
  icon: '🔥',
  title: 'Parrilla & Comidas Caseras',
  description: 'Matambres, sándwiches, empanadas, parrilladas y platos abundantes. Todo cocinado a la parrilla con el cariño de siempre. Porque acá la comida sabe diferente cuando la hacen con ganas.',
  isAlegra: false
}, {
  id: 2,
  icon: '🎶',
  title: 'Shows en Vivo & Eventos',
  description: 'Los fines de semana el patio se llena de música, artistas invitados y cenas show que convierten una salida normal en una noche para recordar. Folclore, cumbia, artistas locales y más.',
  isAlegra: false
}, {
  id: 3,
  icon: '🍹',
  title: 'Barra de Tragos',
  description: 'Tragos clásicos, opciones refrescantes y bebidas para todos los gustos. La barra es el corazón de nuestro patio después de las 21.',
  isAlegra: false
}, {
  id: 4,
  icon: '☕',
  title: 'Allegra Café & Pastelería',
  description: 'Un rincón luminoso dentro del patio, ideal para las tardes. Café de especialidad, tortas caseras y opciones dulces preparadas con amor.',
  isAlegra: true
}, {
  id: 5,
  icon: '👨‍👩‍👧',
  title: 'Espacio Familiar y Reuniones',
  description: '¿Querés festejar un cumple, hacer una salida con el trabajo o simplemente reunir al grupo? El Matambrito tiene espacio para todos.',
  isAlegra: false
}, {
  id: 6,
  icon: '🎉',
  title: 'Reservas para Fechas Especiales',
  description: 'Aniversarios, cumpleaños, despedidas. Organizamos tu evento especial en nuestro patio con menú personalizado y atención dedicada.',
  isAlegra: false
}];
export function Services() {
  return <section id="servicios" className="py-24 bg-matambrito-charcoal relative" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-340">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-341">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-4" data-id="element-342">
            Todo lo que necesitás para una{' '}
            <span className="text-matambrito-gold" data-id="element-343">noche perfecta</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-matambrito-beige font-light" data-id="element-344">
            Un solo lugar. Mil razones para quedarse.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-345">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`rounded-2xl p-8 flex flex-col h-full border transition-all duration-300 hover:-translate-y-2 ${service.isAlegra ? 'bg-matambrito-alegra/10 border-matambrito-alegra/30 hover:shadow-[0_10px_30px_rgba(91,181,181,0.15)]' : 'bg-matambrito-black border-white/5 hover:border-matambrito-gold/30 hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)]'}`} data-id="element-346">
              <div className="text-4xl mb-6 bg-white/5 w-16 h-16 rounded-full flex items-center justify-center" data-id="element-347">
                {service.icon}
              </div>

              <h3 className={`text-2xl font-serif font-bold mb-4 ${service.isAlegra ? 'text-matambrito-alegra' : 'text-matambrito-cream'}`} data-id="element-348">
                {service.title}
              </h3>

              <p className="text-matambrito-beige/80 leading-relaxed flex-grow font-light" data-id="element-349">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}